const CONFIG = {
  checkoutButtonSelector: '#mu-checkout-button',
  cartContainerSelector: '#monster-upsell-cart',
  warningMessageId: 'checkout-warning-msg',
};

function debounce(fn, delay) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, args), delay);
  };
}

function validateCart(cart) {
  const REQUIRED_PRODUCT_SKUS = (window.CHOCOLATE_SKUS || '')
    .split(',')
    .map((sku) => sku.trim().toUpperCase())
    .filter(Boolean);
  if (!REQUIRED_PRODUCT_SKUS || REQUIRED_PRODUCT_SKUS.length === 0) return;

  const MIN_TOTAL = window.CHOCOLATE_MIN_TOTAL || 23;
  const MIN_CHOCOLATE_QTY = window.CHOCOLATE_MIN_QTY || 3;

  // const cartTotal = cart.total_price / 100;
  // const requiredItems = cart.items.filter((item) => REQUIRED_PRODUCT_SKUS.includes(item.sku));

  const checkoutBtn = document.querySelector(CONFIG.checkoutButtonSelector);
  if (!checkoutBtn) return;

  const items = cart.items.map((item) => ({
    ...item,
    sku: (item.sku || '').toUpperCase(),
  }));

  const chocolateItems = items.filter((item) => REQUIRED_PRODUCT_SKUS.includes(item.sku));
  const otherItems = items.filter((item) => !REQUIRED_PRODUCT_SKUS.includes(item.sku));

  if (otherItems.length > 0) {
    updateCheckoutUI(true);
    updateWarningMessage(false);
    return;
  }

  const chocolateQty = chocolateItems.reduce((sum, item) => sum + item.quantity, 0);
  const chocolateTotal = chocolateItems.reduce((sum, item) => sum + item.line_price, 0) / 100;

  // const allowCheckout = chocolateTotal >= MIN_TOTAL && chocolateQty >= MIN_CHOCOLATE_QTY;
  const allowCheckout = true;

  updateCheckoutUI(allowCheckout);
  updateWarningMessage(!allowCheckout);

  // if (requiredItems.length === 0) {
  //   updateCheckoutUI(true);
  //   return;
  // }

  // if (cartTotal < MIN_TOTAL) {
  //   updateCheckoutUI(false);
  //   updateWarningMessage(true);
  //   return;
  // }

  // const chocolateQty = requiredItems.reduce((sum, item) => sum + item.quantity, 0);
  // const chocolateTotal = requiredItems.reduce((sum, item) => sum + item.line_price, 0) / 100;

  // const otherItems = cart.items.filter((item) => !REQUIRED_PRODUCT_SKUS.includes(item.sku));
  // const otherTotal = otherItems.reduce((sum, item) => sum + item.line_price, 0) / 100;

  // let allowCheckout = false;

  // if (
  //   chocolateTotal >= MIN_TOTAL ||
  //   chocolateQty >= MIN_CHOCOLATE_QTY ||
  //   (chocolateTotal < MIN_TOTAL && chocolateQty < MIN_CHOCOLATE_QTY && chocolateTotal + otherTotal >= MIN_TOTAL)
  // ) {
  //   allowCheckout = true;
  // }

  // if (allowCheckout) {
  //   updateCheckoutUI(true);
  //   updateWarningMessage(false);
  // } else {
  //   updateCheckoutUI(false);
  //   updateWarningMessage(true);
  // }
}

const debouncedCartCheck = debounce(() => {
  const checkoutBtn = document.querySelector(CONFIG.checkoutButtonSelector);
  if (checkoutBtn) {
    checkoutBtn.setAttribute('disabled', 'disabled');
    checkoutBtn.style.opacity = '0.5';
  }

  fetchCart().then(validateCart);
}, 300);

function waitForCartToAppear(callback, maxAttempts = 30, interval = 300) {
  let attempts = 0;
  const timer = setInterval(() => {
    const cart = document.querySelector(CONFIG.cartContainerSelector);
    if (cart) {
      clearInterval(timer);
      callback(cart);
    } else {
      attempts++;
      if (attempts >= maxAttempts) {
        clearInterval(timer);
      }
    }
  }, interval);
}

function updateWarningMessage(show) {
  const messageId = CONFIG.warningMessageId;
  const existing = document.querySelector(`#${messageId}`);
  const messageHTML = window.CHOCOLATE_MESSAGE || 'Default fallback message';

  const checkoutBtn = document.querySelector(CONFIG.checkoutButtonSelector);
  if (!checkoutBtn) return;

  if (show) {
    if (!existing) {
      const msg = document.createElement('div');
      msg.id = messageId;
      msg.innerHTML = messageHTML;
      msg.style.fontSize = '1.2rem';
      msg.style.marginBottom = '6px';
      msg.style.textAlign = 'left';

      checkoutBtn.insertAdjacentElement('beforebegin', msg);
    }
  } else {
    if (existing) {
      existing.remove();
    }
  }
}

function updateCheckoutUI(allow) {
  const checkoutBtn = document.querySelector(CONFIG.checkoutButtonSelector);
  if (!checkoutBtn) return;

  if (!allow) {
    checkoutBtn.setAttribute('disabled', 'disabled');
    checkoutBtn.style.opacity = '0.5';
    checkoutBtn.style.pointerEvents = 'none';
  } else {
    checkoutBtn.removeAttribute('disabled');
    checkoutBtn.style.opacity = '1';
    checkoutBtn.style.pointerEvents = 'auto';
  }
}

function setupCartObserver(cartContainer) {
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        debouncedCartCheck();
        break;
      }
    }
  });

  observer.observe(cartContainer, {
    childList: true,
    subtree: true,
  });
}

document.addEventListener('click', (e) => {
  const btn = e.target.closest(CONFIG.checkoutButtonSelector);
  if (btn) {
    btn.setAttribute('disabled', 'disabled');
    btn.style.opacity = '0.5';
    btn.style.pointerEvents = 'none';

    setTimeout(() => {
      fetchCart().then(validateCart);
    }, 150);
  }
});

function fetchCart() {
  return fetch('/cart.js').then((res) => res.json());
}

document.addEventListener('DOMContentLoaded', () => {
  waitForCartToAppear(setupCartObserver);
});
